export { default } from "./TeamProps";
